<template>
  <div
    class="checkbox-item"
    :class="{ 'checkbox-item-active': isCheck }"
    :style="{ width: getWidth(rows) }"
    @click="bindCheck"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String | Number,
      default: ''
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      checked: false
    }
  },
  computed: {
    isCheck() {
      return (
        this.checked === this.value ||
        (Array.isArray(this.checked) && this.checked.includes(this.value))
      )
    }
  },
  created() {
    this.checked = this
  },
  methods: {
    getWidth(num) {
      let space = 2.4
      let width = (100 - space * (num - 1)) / num
      return width.toFixed(2) + '%'
    },
    bindCheck() {
      this.$parent && this.$parent.updateCheck(this.value, this.data)
    }
  }
}
</script>
<style lang="scss" scoped>
.checkbox-item {
  width: 100%;
  border-radius: 8px;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #8E8D9B;
  line-height: 22px;
  box-sizing: border-box;
  margin-bottom: 10px;
  overflow: hidden;
}
.checkbox-item {
  .checkbox-text {
    background: #f5f6fa;
  }
}
.checkbox-item-active {
  font-weight: bold;
  color: #fe0932;
  .checkbox-text {
    background: linear-gradient(180deg, #e3ccf8 0%, #ca9fec 100%);
  }
}
</style>
